// removed by extract-text-webpack-plugin
module.exports = {"component":"_3_HK3g-sLSvGLJ2y9HT9db","header":"_3Cfa-4q0ifQbQsECJJc6kw","secondaryText":"_2Lj1XN1As1BHsvFNwfzpqa","message":"_2VO1-zyzx7Y51GE3BVZl3J","btn":"_3a1VcJq5Mq3ChxPasJ7uuk","link":"_1jxO698sPJ0MHjjO8FYCCF","verticalSpacing":"_3zFmI61uK4pA8V3yjoE2js"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/VerifyDob/VerifyDobForm.css
// module id = 1198
// module chunks = 0